import React, { forwardRef, Ref, SVGProps } from 'react'

const _IconHotelTonightRectangle = (props: SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) => (
  <svg width="72" height="74" viewBox="0 0 74 74" fill="none" {...props} ref={ref}>
    <g filter="url(#filter0_d)">
      <rect x="12" y="12" width="50" height="50" rx="14" fill="#3B2151"></rect>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.4517 27.3225H23.2904V35.3871L51.5161 35.387H56.3548L56.3549 35.3871V40.2258H56.3548V46.6774H51.5161V40.2258H23.2904V46.6773H18.4517V27.3225Z"
        fill="white"
      ></path>
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="0"
        y="0"
        width="74"
        height="74"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        ></feColorMatrix>
        <feOffset></feOffset>
        <feGaussianBlur stdDeviation="6"></feGaussianBlur>
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        ></feColorMatrix>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"></feBlend>
      </filter>
    </defs>
  </svg>
)

export const IconHotelTonightRectangle = forwardRef(_IconHotelTonightRectangle)
